import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    TableRow,
    TableRowColumn
} from 'material-ui/Table';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentDelete from 'material-ui/svg-icons/action/delete';

/**
 * A component for creating a Location Price row with optional deletion.
 * Loaded by LocationPriceTable.
 *
 */
class LocationPriceTableRow extends Component {
    constructor(props) {
        super(props);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
    }

    handleDeleteClick() {
        this.props.onDeleteClick(this.props.location_id);
    }

    render() {
        const styles = {
            block: {display: 'block'},
            row: {height: '40px'},
            alignTop: {verticalAlign: 'top'},
            icon: {height: '40px', padding: '10px', overflow: 'inherit'},
            fieldSmall: {display: 'inline-block', maxWidth: 100, maxHeight: 62},
        };
        return (
            <TableRow style={styles.row}>
                <TableRowColumn className={'row-location-' + this.props.price_level} style={styles.row}>
                    <span>{this.props.location_id}</span>
                </TableRowColumn>

                <TableRowColumn className={'row-location-price-' + this.props.price_level} style={styles.row}>
                    <span>{this.props.price}</span>
                </TableRowColumn>

                <TableRowColumn style={styles.row}>
                    {this.props.showDelete &&
                    <IconButton
                        style={styles.icon}
                        onClick={(e) => this.handleDeleteClick(e)}
                    >
                        <ContentDelete color={FuseTheme.palette.primary1Color}/>
                    </IconButton>
                    }
                </TableRowColumn>
            </TableRow>
        )
    }
}

LocationPriceTableRow.propTypes = {
    addField: PropTypes.bool,
    location_id: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    showDelete: PropTypes.bool,
    onDeleteClick: PropTypes.func,
};

LocationPriceTableRow.defaultProps = {
    addField: true,
    price_level: '',
    price: 0,
    style: {padding: 0},
};

export default LocationPriceTableRow;


// WEBPACK FOOTER //
// ./src/Fuse/components/LocationPriceTableRow.js